export default __webpack_public_path__ + "static/0034-ca72f2f0bd08d7264d312e93d926538a.png";